import ValidationType from '../ValidationType';
import { datesAreEqual, dateIsBefore } from "../../dateutil";
import moment from 'moment-timezone';

class BeforeDateFieldEx extends ValidationType {

  get comparesField() {
    return true
  }

  validateResponseWithValidation(fieldResponse, validation, formResponse = null) {
    let errors = [];
    if (!fieldResponse.isEmpty) {
      if (validation.target) {
        const targetFieldResponse = formResponse
          ? fieldResponse.recapResponse.getFieldResponseForFieldInstanceIdAndFormResponseId(validation.target.id, formResponse.id)
          : fieldResponse.recapResponse.getFieldResponseForFieldInstanceId(validation.target.id);
        const current = moment(fieldResponse.currentValue).utcOffset(moment(fieldResponse.currentValue).utcOffset() ).format('YYYY-MM-DD');
        const compare = moment(targetFieldResponse.currentValue).utcOffset(moment(targetFieldResponse.currentValue).utcOffset()).format('YYYY-MM-DD');
        if ( !dateIsBefore(current, compare)) {
          const error = this.createValidationError({
            fieldResponse,
            key: 'ERROR_BEFORE_SPECIFIED_FIELD_EX',
            values: { value: targetFieldResponse.currentValue },
            message: `Value should be before:  '${compare}'`,
          });
          errors.push(error);
        }
      } else {
        console.warn("No target present for validation", validation);
      }
    }
    return errors;
  }
}

export default BeforeDateFieldEx;
